import React from 'react';
import { Mail, RefreshCw, Gift } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      step: '01',
      title: 'Get Your Invite',
      description: 'Join our exclusive invite-only program and get started with 100GB free storage.',
      icon: Mail
    },
    {
      step: '02',
      title: 'Sync Your Devices',
      description: 'Download Drivault on all your devices and sync your files seamlessly.',
      icon: RefreshCw
    },
    {
      step: '03',
      title: 'Invite & Earn',
      description: 'Invite up to 9 friends and earn up to 1TB of free storage.',
      icon: Gift
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Getting Started is <span className="text-[#40E095]">Simple</span>
          </h2>
          <p className="text-lg text-gray-600">
            Three easy steps to secure cloud storage that works everywhere
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 max-w-6xl mx-auto">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div key={index} className="relative">
                {/* Connector Line (hidden on mobile, shown on md+) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-gradient-to-r from-[#40E095] to-[#40E095]/30 transform -translate-y-1/2"></div>
                )}
                
                <div className="relative z-10 text-center space-y-4">
                  {/* Step Number & Icon */}
                  <div className="flex flex-col items-center">
                    <div className="bg-[#40E095] text-white w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold mb-4 shadow-lg">
                      {step.step}
                    </div>
                    <div className="bg-[#40E095]/10 p-6 rounded-2xl inline-flex">
                      <IconComponent className="text-[#40E095]" size={40} />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Image */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src="https://images.unsplash.com/photo-1586952518485-11b180e92764" 
              alt="Seamless workflow" 
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
